
import { bl_dgmkt_project_message_template_link_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class DgMktProjectMessageTemplateLinkContainerModel extends BaseContainerModel {
  bl_dgmkt_project_message_template_link: bl_dgmkt_project_message_template_link_RowClass = new bl_dgmkt_project_message_template_link_RowClass();
}
